module.exports = __webpack_public_path__ + "img/946.62381f39.png";